import { BsEyeFill, BsEyeSlashFill } from 'react-icons/bs';

export const Icones = {
  olhoAberto: (tam?: number) => <BsEyeFill size={`${tam ?? 1}rem`} />,
  olhoFechado: (tam?: number) => <BsEyeSlashFill size={`${tam ?? 1}rem`} />,
};
